<template>
    <div class="toolbar__player">
        <PlayerWave v-if="showWavePlayer" :src="audio" rewind-button @playing="signalPlay" />
        <PlayerSimple v-else class="player--round" :src="audio || null" @playing="signalPlay" />
        <div v-if="!audio" class="toolbar__player-error">
            No audio is generated for this sentence
        </div>
        <div class="toolbar__player-switcher">
            <span class="toolbar__player-switcher-label">
                {{ $t('editor.toolbar.switchPlayer') }}
            </span>
            <span class="toolbar__player-switcher-btn">
                <Switcher v-model="showWavePlayer" @update:model-value="savePlayerType" />
            </span>
        </div>
    </div>
</template>

<script>
import { PlayerWave, PlayerSimple } from '@speechki-frontend/shared/ui/Player';
import Switcher from '@speechki-frontend/shared/ui/Switcher';

export default {
    name: 'EditorToolbarPlayer',
    components: {
        PlayerWave,
        PlayerSimple,
        Switcher
    },
    props: {
        audio: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            showWavePlayer: true
        };
    },

    created() {
        this.showWavePlayer = this.getPlayerType();
    },

    methods: {
        savePlayerType() {
            localStorage.setItem('showWavePlayer', this.showWavePlayer);
        },

        getPlayerType() {
            const data = localStorage.getItem('showWavePlayer');
            if (data === 'false') return false;
            else if (data === 'true') return true;
            else
                return !(
                    window.navigator.userAgent.indexOf('Edge') > -1 || !window.AbortController
                );
        },

        signalPlay() {
            this.$emit('play');
        }
    }
};
</script>
